/**
 * Ported VERBATIM from `apr_template/src/pages/HelpSupport.tsx`.
 * Only import paths change. See ../compat/ for the shims.
 */
import React from 'react';
import PageHeader from '../compat/PageHeader';

const HelpSupport: React.FC = () => {
  return (
    <div className="help-support-container">
      <PageHeader
        title="Help & Support"
        subtitle="Get assistance with the APR Framework - we're here to help"
      />

      <div className="help-support-content">
        {/* Contact Information Section */}
        <div className="support-section">
          <div className="section-header">
            <h2>Contact Information</h2>
          </div>
          <div className="contact-cards">
            <div className="contact-card primary">
              <div className="contact-photo">
                <img
                  src={`${process.env.PUBLIC_URL}/goran-lucic.jpg`}
                  alt="Goran Lucic"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextElementSibling?.classList.remove('hidden');
                  }}
                />
                <div className="photo-placeholder hidden">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
              </div>
              <div className="contact-details">
                <h3>Primary Contact</h3>
                <div className="contact-name">Goran Lucic</div>
                <div className="contact-info">
                  <a href="mailto:goran.lucic@talogent.com">
                    goran.lucic@talogent.com
                  </a>
                </div>
                <div className="contact-info">
                  <a href="tel:+14045470589">+1.404.547.0589</a>
                </div>
              </div>
            </div>

            <div className="contact-card primary">
              <div className="contact-photo">
                <img
                  src={`${process.env.PUBLIC_URL}/joe-schuller.jpg`}
                  alt="Joe Schuller"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextElementSibling?.classList.remove('hidden');
                  }}
                />
                <div className="photo-placeholder hidden">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
              </div>
              <div className="contact-details">
                <h3>Primary Contact</h3>
                <div className="contact-name">Joe Schuller</div>
                <div className="contact-info">
                  <a href="mailto:joe.schuller@talogent.com">
                    joe.schuller@talogent.com
                  </a>
                </div>
                <div className="contact-info">
                  <a href="tel:+16784785014">+1.678.478.5014</a>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Department Contacts Section */}
        <div className="support-section">
          <div className="section-header">
            <h2>Department Contacts</h2>
          </div>
          <div className="department-grid">
            <div className="department-card">
              <div className="department-icon support">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <h3>Technical Support</h3>
              <p>Get help with technical issues, bugs, and system problems</p>
              <a href="mailto:support@talogent.com" className="department-email">
                support@talogent.com
              </a>
            </div>

            <div className="department-card">
              <div className="department-icon sales">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <h3>Sales</h3>
              <p>Inquiries about licensing, pricing, and enterprise solutions</p>
              <a href="mailto:support@talogent.com" className="department-email">
                support@talogent.com
              </a>
            </div>

            <div className="department-card">
              <div className="department-icon marketing">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
              </div>
              <h3>Marketing</h3>
              <p>Partnership opportunities, media inquiries, and promotions</p>
              <a href="mailto:support@talogent.com" className="department-email">
                support@talogent.com
              </a>
            </div>
          </div>
        </div>

        {/* Need Additional Help — single call to action for anything the cards above
            don't cover. Mirrors the same block in the AI Readiness user guide. */}
        <div className="support-section">
          <div className="need-help-cta">
            <svg className="need-help-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
              <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
            </svg>
            <h3>Need Additional Help?</h3>
            <p>Our support team is ready to assist you with any questions.</p>
            <a href="mailto:support@talogent.com" className="contact-support-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
              Contact Support
            </a>
          </div>
        </div>

        {/* Quick Help Section */}
        <div className="support-section">
          <div className="section-header">
            <h2>Quick Help</h2>
          </div>
          <div className="quick-help-content">
            <div className="help-tips">
              <div className="help-tip">
                <h4>Getting Started</h4>
                <p>New to APR Framework? Check out the User Guide for comprehensive documentation and step-by-step instructions.</p>
              </div>
              <div className="help-tip">
                <h4>Reporting Issues</h4>
                <p>When reporting an issue, please include your browser version, steps to reproduce, and any error messages you see.</p>
              </div>
              <div className="help-tip">
                <h4>Response Times</h4>
                <p>We aim to respond to all support inquiries within 24-48 business hours. Urgent issues are prioritized.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        /*
          FULL WIDTH, like every other screen. The owner (2026-08-08): "the screen width
          is not in line with general dimensions of the screen."

          APR's theme sets a content max-width of none — "every screen uses all
          available space" — and the shell's main element already supplies the
          horizontal padding. A 1200px centred column made this the one screen that floated in the
          middle of a wide monitor while its neighbours filled it.
        */
        .help-support-container {
          padding: 24px 0;
        }

        .page-header {
          margin-bottom: 32px;
          text-align: center;
        }

        .page-title {
          color: #1976d2;
          margin-bottom: 8px;
          font-size: 2.5rem;
          font-weight: 600;
        }

        .page-subtitle {
          color: #666;
          font-size: 1.1rem;
          margin: 0;
        }

        .support-section {
          margin-bottom: 32px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          overflow: hidden;
        }

        .section-header {
          background: white;
          color: #333;
          padding: 20px 24px;
          border-bottom: 2px solid #e0e0e0;
        }

        .section-header h2 {
          margin: 0;
          font-size: 1.4rem;
          font-weight: 600;
          color: #1976d2;
        }

        .contact-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          padding: 24px;
        }

        .contact-card {
          display: flex;
          align-items: center;
          gap: 24px;
          padding: 24px;
          background: #f8f9fa;
          border-radius: 8px;
          border-left: 4px solid #1976d2;
        }

        .contact-card.primary {
          background: linear-gradient(135deg, #f8f9fa 0%, #e8f4fc 100%);
        }

        .contact-photo {
          flex-shrink: 0;
        }

        .contact-photo img {
          width: 160px;
          height: 160px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center 20%;
          border: 3px solid #1976d2;
          box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
        }

        .photo-placeholder {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: #e3f2fd;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1976d2;
          border: 3px solid #1976d2;
        }

        .photo-placeholder.hidden {
          display: none;
        }

        .contact-details h3 {
          color: #1976d2;
          margin: 0 0 8px 0;
          font-size: 1rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .contact-name {
          font-size: 1.5rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 12px;
        }

        .contact-info {
          margin-bottom: 8px;
        }

        .contact-info a {
          color: #1976d2;
          text-decoration: none;
          font-size: 1.1rem;
        }

        .contact-info a:hover {
          text-decoration: underline;
        }

        .department-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 24px;
          padding: 24px;
        }

        /* Need Additional Help — this card has no section-header bar, so it carries its own
           padding and centred layout. */
        .need-help-cta {
          padding: 28px 24px;
          text-align: center;
          background: linear-gradient(135deg, #e3f2fd 0%, #fafcff 100%);
        }

        .need-help-icon {
          color: #1976d2;
          margin-bottom: 12px;
        }

        .need-help-cta h3 {
          margin: 0 0 8px;
          font-size: 20px;
          color: #333;
        }

        .need-help-cta p {
          margin: 0 0 20px;
          color: #666;
          font-size: 15px;
        }

        .contact-support-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 24px;
          background: #1976d2;
          color: #fff;
          text-decoration: none;
          border-radius: 8px;
          font-weight: 500;
          font-size: 15px;
          transition: background 0.2s;
        }

        .contact-support-btn:hover {
          background: #1565c0;
        }

        .department-card {
          background: #f8f9fa;
          padding: 24px;
          border-radius: 8px;
          text-align: center;
          transition: transform 0.2s, box-shadow 0.2s;
        }

        .department-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .department-icon {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
        }

        .department-icon.support {
          background: #e3f2fd;
          color: #1976d2;
        }

        .department-icon.sales {
          background: #e8f5e9;
          color: #388e3c;
        }

        .department-icon.marketing {
          background: #fff3e0;
          color: #f57c00;
        }

        .department-card h3 {
          color: #333;
          margin: 0 0 8px 0;
          font-size: 1.2rem;
        }

        .department-card p {
          color: #666;
          margin: 0 0 16px 0;
          font-size: 0.95rem;
          line-height: 1.5;
        }

        .department-email {
          display: inline-block;
          color: #1976d2;
          text-decoration: none;
          font-weight: 500;
          padding: 8px 16px;
          background: white;
          border-radius: 4px;
          border: 1px solid #1976d2;
          transition: all 0.2s;
        }

        .department-email:hover {
          background: #1976d2;
          color: white;
        }

        .quick-help-content {
          padding: 24px;
        }

        .help-tips {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
        }

        .help-tip {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          border-left: 4px solid #4caf50;
        }

        .help-tip h4 {
          color: #333;
          margin: 0 0 8px 0;
          font-size: 1.1rem;
        }

        .help-tip p {
          color: #666;
          margin: 0;
          font-size: 0.95rem;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .help-support-container {
            padding: 16px;
          }

          .contact-cards {
            grid-template-columns: 1fr;
          }

          .contact-card {
            flex-direction: column;
            text-align: center;
          }

          .page-title {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default HelpSupport;
